import { useEffect } from 'react';
import { useToast } from './Toast';
import { onDemoModeChanged, demoToastMessage } from '../hooks/useDemoMode';

/** Renders nothing; announces demo-mode switches made from the account menu or map ribbon. */
export default function DemoModeToaster() {
  const { showToast } = useToast();
  useEffect(() => onDemoModeChanged((on) => showToast(demoToastMessage(on), 'info')), [showToast]);
  return null;
}
